import { render, staticRenderFns } from "./SystemComponentUpdate.vue?vue&type=template&id=488350fd&"
import script from "./SystemComponentUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemComponentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports